import {Metrics, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalConverterHeaderFooterMargins implements Parameter {
	public top?: number;
	public left?: number;
	public bottom?: number;
	public right?: number;
	public metrics?: Metrics;

	constructor(data: any) {
		this.metrics = FunctionHelper.exists(data?.metrics) ? data?.metrics : Metrics.Px;
		this.top = FunctionHelper.exists(data?.top) ? data.top : 0;
		this.left = FunctionHelper.exists(data?.left) ? data.left : 0;
		this.bottom = FunctionHelper.exists(data?.bottom) ? data.bottom : 0;
		this.right = FunctionHelper.exists(data?.right) ? data.right : 0;
	}

	public static getTopDefault(): number {
		return 0;
	}

	public static getLeftDefault(): number {
		return 0;
	}

	public static getBottomDefault(): number {
		return 0;
	}

	public static getRightDefault(): number {
		return 0;
	}

	public static getMetricsDefault(): Metrics {
		return Metrics.Px;
	}

	public static fromJson(data: any): PortalConverterHeaderFooterMargins {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalConverterHeaderFooterMargins(data);
	}

	public toJson(): any {
		return {
			"top": this.top,
			"left": this.left,
			"bottom": this.bottom,
			"right": this.right,
			"metrics": this.metrics,
		};
	}

	public clone(): PortalConverterHeaderFooterMargins {
		return PortalConverterHeaderFooterMargins.fromJson(this.toJson());
	}
}